import {
  profileApi,
  updateTasksInformationData,
  DynamicObjectInterface,
  GetTaskResType,
} from '@commerce-profile-webcomponents/sdk';
import { Breakpoints } from '@nextgen-web-framework/all';
import { StorageService } from '@nextgen-web-framework/core';
import { defaultApiErrorHandler } from './helper';
import { CONTACT_TASK_KEY } from './Constants';

export const getTaskListUtil = (
  dispatch: DynamicObjectInterface,
  accountNumber: string,
  apiErrorHandler = defaultApiErrorHandler,
) => {
  const cookie = StorageService.getCookieStorage();
  const cookieVal = cookie.retrieve('tasks-completed');
  const tasksCookieVal = cookieVal === 'true' ? true : cookieVal === 'false' ? false : null;

  if (tasksCookieVal) {
    dispatch(
      updateTasksInformationData({
        taskCompleted: tasksCookieVal,
        tasks: {},
      }),
    );
  } else {
    apiErrorHandler(() => profileApi.getTaskList(accountNumber)).then((tasksList: GetTaskResType) => {
      if (tasksList?.tasks?.filter((t) => t.status === 'INCOMPLETE').length === 0) {
        cookie.store('tasks-completed', 'true');
      } else {
        dispatch(
          updateTasksInformationData({
            taskCompleted: tasksCookieVal,
            ...tasksList,
          }),
        );
      }
    });
  }
};

export const getContactTaskListUtil = async (accountNumber: string, task_Keys: string[]) => {
  const session = StorageService.getSessionStorage();
  const checkTaskLater = session.retrieve(CONTACT_TASK_KEY);

  try {
    const tasksList = await profileApi.getTaskList(accountNumber);
    if (tasksList?.tasks?.length && !checkTaskLater) {
      let isTaskIncomplete = false;
      tasksList.tasks.push({
        id: 'c43e6669-9409-534b-9644-984a5ca0adcc',
        version: 5,
        accountNumber: 7025327476,
        type: 'REVERIFY_EMAIL',
        status: 'INCOMPLETE',
      });
      for (const tk of task_Keys) {
        const incompleteTask = tasksList?.tasks?.filter((t) => t.type === tk && t.status === 'INCOMPLETE');
        if (incompleteTask?.length > 0) {
          isTaskIncomplete = true;
          break; // if any incomplete task is found
        }
      }
      if (isTaskIncomplete) {
        return { showContactModal: true };
      }
    }
    return { showContactModal: false };
  } catch {
    return { showContactModal: false };
  }
};

export const isMobileView = (viewPortType: string) =>
  [Breakpoints.XS, Breakpoints.SM].indexOf(viewPortType as Breakpoints) !== -1;

export const handleAPIResponseError = (err: DynamicObjectInterface) => {
  const errObj = JSON.parse(JSON.stringify(err));
  return errObj?.responseBody?.code ?? '';
};

export const handleUIResize = ({
  contentContainerRef,
  styles,
  buttonBarId,
  ignoreOverflow,
  forceButtonLeftPos = false,
}: DynamicObjectInterface) => {
  const contentContainerRect = contentContainerRef?.current?.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const buttonBar = document.getElementById(buttonBarId);

  const staticBarClass = styles['static-action-bar'];

  // Check if content is outside the display area
  if (buttonBar) {
    const isOverflow = ignoreOverflow
      ? false
      : contentContainerRect && contentContainerRect?.bottom > windowHeight - 96 - 24;

    const leftPos = isOverflow || forceButtonLeftPos ? `${contentContainerRect?.left ?? 0}px` : '0px';

    if (isOverflow) {
      buttonBar?.classList.add(staticBarClass);
    } else {
      buttonBar?.classList.remove(staticBarClass);
    }

    document.documentElement.style.setProperty('--dynamic-left', leftPos);
  }
};

export const handleMobileUIButtonBar = (buttonBarId: string) => {
  const buttonBar = document.getElementById(buttonBarId);
  if (buttonBar) {
    buttonBar.style.left = '';
  }
};

export function appendSlashInDOB(e: React.ChangeEvent<HTMLInputElement>) {
  const { value, selectionStart } = e.target;
  let inputValue = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
  if (inputValue.length > 8) {
    inputValue = inputValue.slice(0, 8);
  }
  // Format the input value with '/' after every 2 characters
  let formattedValue = '';
  if (inputValue.length > 0) {
    formattedValue += inputValue.slice(0, 2); // First 2 characters
  }
  if (inputValue.length > 2) {
    formattedValue += `/${inputValue.slice(2, 4)}`; // Next 2 characters
  }
  if (inputValue.length > 4) {
    formattedValue += `/${inputValue.slice(4, 8)}`; // Last 4 characters
  }
  let newCursorPosition = selectionStart || 0;
  // Adjust cursor position to account for slashes being added or removed
  const previousValue = value;
  if (previousValue.length < formattedValue.length && (newCursorPosition === 3 || newCursorPosition === 6)) {
    newCursorPosition += 1;
  } else if (previousValue.length > formattedValue.length && (newCursorPosition === 3 || newCursorPosition === 6)) {
    newCursorPosition -= 1;
  }
  return {
    newCursorPosition,
    formattedValue,
  };
}

export const getDropdownYears = (maxAge?: number, minAge?: number) => {
  const currentYear = new Date().getFullYear();
  const minYear = currentYear - (maxAge || 100);
  const maxYear = currentYear - (minAge || 10);

  const yearList: DynamicObjectInterface[] = [];

  for (let yr = maxYear; yr >= minYear; yr--) {
    yearList.push({
      label: yr,
      value: yr,
    });
  }
  return yearList;
};
